import React, { Component } from 'react';
import { TextField, Grid, Typography, MenuItem } from "@material-ui/core";
import ImageUploader from 'react-images-upload';

import './Step.scss';

class AttributForm extends Component {
  
render() {
    return (
	   <>
        <Grid item xs={12}>
            <Typography variant="h6">Attribute</Typography>
        </Grid>
        <Grid item xs={12} sm={8}>
            <TextField
                label="Bezeichnung"
                name="name_nummer"
                variant="outlined"
                fullWidth
				value={this.props.values.name_nummer}
                onChange={this.props.handleChange}
				id={'name_nummer' + this.props.values.id}
				className="step-input"
            />
        </Grid>
        <Grid item xs={12} sm={4}>
            <TextField
                label="Feature-ID"
                name="fid"
                variant="outlined"
                fullWidth
				id={'fid' + this.props.values.id}
				value={this.props.values.fid}
                onChange={this.props.handleChange}
				className="step-input"
            />
        </Grid>
        <Grid item xs={12} sm={12}>
            <TextField
                label="Standort"
                name="standort"
                variant="outlined"
                fullWidth
				id={'standort' + this.props.values.id}
				value={this.props.values.standort}
                onChange={this.props.handleChange}
				className="step-input"
            />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'zugang' + this.props.values.id}
            select
            label="Zugang"
            name="id_zugang"
		    variant="outlined"
			required
		    fullWidth
		    className="step-input"
            value={this.props.values.id_zugang}
            onChange={this.props.handleChange}
          >
            {this.props.ewSchachtZugang.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'lagebestimmung' + this.props.values.id}
            select
            label="Lagebestimmung"
		    name="id_lagebestimmung"
		    variant="outlined"
		    fullWidth
		    className="step-input"
            value={this.props.values.id_lagebestimmung}
            onChange={this.props.handleChange}
          >
            {this.props.ewSchachtLagebestimmung.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'typ' + this.props.values.id}
            select
            label="Typ"
		    name="id_typ"
		    variant="outlined"
		    fullWidth
		    className="step-input"
            value={this.props.values.id_typ}
            onChange={this.props.handleChange}
          >
            {this.props.ewSchachtTyp.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id={'eigentuemer' + this.props.values.id}
            select
            label="Eigentümer"
		    name="id_eigentuemer"
		    variant="outlined"
		    fullWidth
		    className="step-input"
            value={this.props.values.id_eigentuemer}
            onChange={this.props.handleChange}
          >
            {this.props.ewSchachtEigentuemer.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.value}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Dimension 1 [mm]"
            name="dimension_1"
            variant="outlined"
            fullWidth
		    id={'dimension_1' + this.props.values.id}
		    value={this.props.values.dimension_1}
            onChange={this.props.handleChange}
		    className="step-input"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Dimension 2 [mm]"
            name="dimension_2"
            variant="outlined"
            fullWidth
		    id={'dimension_2' + this.props.values.id}
		    value={this.props.values.dimension_2}
            onChange={this.props.handleChange}
		    className="step-input"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Baujahr"
            name="baujahr"
            variant="outlined"
            fullWidth
		    id={'baujahr' + this.props.values.id}
		    value={this.props.values.baujahr}
            onChange={this.props.handleChange}
		    className="step-input"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            label="Überdeckung"
            name="ueberdeckung"
            variant="outlined"
            fullWidth
		    id={'ueberdeckung' + this.props.values.id}
		    value={this.props.values.ueberdeckung}
            onChange={this.props.handleChange}
		    className="step-input"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
			id={'bemerkung' + this.props.values.id}
            label="Bemerkung"
            name="bemerkung"
            variant="outlined"
            fullWidth
			value={this.props.values.bemerkung}
            onChange={this.props.handleChange}
			className="step-input"
          />
        </Grid>
		<Grid item xs={12}>
           <Typography variant="h6">Fotos</Typography>
        </Grid>
		<Grid item xs={12}>
           <ImageUploader
		       optimisticPreviews
               withIcon={true}
			   withPreview={true}
               buttonText='Bild Auswählen'
               onChange={this.props.onImgDrop}
               imgExtension={['.jpg', '.gif', '.png', '.jpeg']}
			   fileTypeError="Der Datei-Typ wird nicht unterstützt"
               maxFileSize={10485760}
			   fileSizeError="die Datei ist zu gross"
			   label="Übersichts-Bild (2x) aufnehmen"
           />
		 </Grid>
    </>
	)
}
}

export default AttributForm;
